<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="num-show div-table-row">
            <div class="div-table-cell gotoReBack" style="width: 20%">
                <div @click="gotoReBack" v-if="permission.applyAfter">
                    <p>
                        <img src="../../../assets/images/sh.png" alt />
                    </p>
                    <p>{{ permission.applyAfter }}</p>
                </div>
            </div>
            <div class="div-table-cell" style="width: 20%">
                <p class="num-value">{{ statistics.ProcessingCount }}</p>
                <p class="num-name">处理中</p>
            </div>
            <div class="div-table-cell" style="width: 20%">
                <p class="num-value">{{ statistics.RefundingCount }}</p>
                <p class="num-name">退款中</p>
            </div>
            <div class="div-table-cell" style="width: 20%">
                <p class="num-value">{{ statistics.WaitingSendingCount }}</p>
                <p class="num-name">待邮寄</p>
            </div>
            <div class="div-table-cell" style="width: 20%">
                <p class="num-value">{{ statistics.CompletedCount }}</p>
                <p class="num-name">已完成</p>
            </div>
        </div>
        <div class="reBack-table">
            <div class="div-table-row reBack-title">
                <div class="div-table-cell" style="width: 20%">返修/退换货编号</div>
                <div class="div-table-cell" style="width: 20%">订单编号</div>
                <div class="div-table-cell" style="width: 30%">商品名称</div>
                <div class="div-table-cell" style="width: 10%">
                    <select v-model="applyDateSelected" @change="applyDateChange(applyDateSelected)">
                        <option :key="index" v-for="(item, index) in applyDate" :vlaue="item.value">{{ item.key }}</option>
                    </select>
                </div>
                <div class="div-table-cell" style="width: 10%">
                    <select v-model="searchData.State" @change="getOrderList()">
                        <option value>全部状态</option>
                        <option :key="index" v-for="(item, index) in orderState" :value="item.Value">{{ item.Text }}</option>
                    </select>
                </div>
                <div class="div-table-cell" style="width: 10%">操作</div>
            </div>
            <template v-if="tableDataLength != 0">
                <div class="div-table-row reBack-data" :key="index" v-for="(item, index) in reBackData">
                    <div class="div-table-cell" style="width: 20%">{{ item.AOrderSn }}</div>
                    <div class="div-table-cell" style="width: 20%">{{ item.OrderSN }}</div>
                    <div class="div-table-cell" style="width: 30%">
                        <el-tooltip effect="light">
                            <div slot="content">
                                <div :key="index" v-for="(i, index) in item.DetailList" class="goods-item">
                                    <img :src="downloadUrl + i.ShowImg" :onerror="defaultImg" :title="i.GoodName" />
                                </div>
                            </div>
                            <div style="display: flex" v-if="item.DetailList">
                                <div v-if="item.DetailList[0]" class="goods-show">
                                    <img :src="downloadUrl + item.DetailList[0].ShowImg" :onerror="defaultImg" :title="item.DetailList[0].GoodName" />
                                </div>
                                <div v-if="item.DetailList[1]" class="goods-show">
                                    <img :src="downloadUrl + item.DetailList[1].ShowImg" :onerror="defaultImg" :title="item.DetailList[1].GoodName" />
                                </div>
                                <div v-if="item.DetailList[2]" class="goods-show">
                                    <img :src="downloadUrl + item.DetailList[2].ShowImg" :onerror="defaultImg" :title="item.DetailList[2].GoodName" />
                                </div>
                                <div v-if="item.DetailList[3]" class="goods-show">......</div>
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="div-table-cell" style="width: 10%">{{ item.ApplyTime }}</div>
                    <div class="div-table-cell" style="width: 10%">{{ item.StateName }}</div>
                    <div class="div-table-cell" style="width: 10%">
                        <span class="cancel" @click="cancel(item)" v-if="permission.cancel">{{ permission.cancel }}</span>
                    </div>
                </div>
            </template>
            <div class="div-table-row" v-else>
                <div class="div-table-cell no-data" style="width: 100%">暂无返修/退还货申请信息</div>
            </div>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        return {
            defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE + '"',
            downloadUrl: this.$util.QN_URL_BASE,
            applyDateSelected: '申请时间',
            applyDate: [
                {
                    key: '申请时间',
                    value: '0'
                },
                {
                    key: '最近三个月',
                    value: '1'
                },
                {
                    key: '三个月前',
                    value: '2'
                }
            ],
            beforeThreeMonth: '',
            orderState: [], // 订单状态
            statistics: {},
            reBackData: [],
            searchData: {
                UserId: this.$util.getLocalStorage('userMsg').EmployeeId,
                OrderCode: '',
                BeginDate: '',
                EndDate: '',
                State: '',
                page: 1,
                limit: 15,
                key: ''
            },
            tableDataLength: 0,
            permission: {}
        };
    },
    mounted() {
        this.getStatistics();
        this.getOrderState();
        this.getOrderList();
        this.beforeThreeMonth = this.getMonthDate(-3);
        this.permission = this.$util.getPermission('AfterSale');
    },
    methods: {
        applyDateChange(value) {
            if (value == '申请时间') {
                this.searchData.BeginDate = '';
                this.searchData.EndDate = '';
            } else if (value == '最近三个月') {
                this.searchData.BeginDate = this.beforeThreeMonth;
                this.searchData.EndDate = this.$util.getNowFormatDate();
            } else {
                this.searchData.BeginDate = '';
                this.searchData.EndDate = this.beforeThreeMonth;
            }
            this.getOrderList();
        },
        // 获取订单列表
        getOrderList() {
            this.$util
                .axiosGet({
                    url: `/api/MallSaleOrder/GetSaleOrderAfterSaleList`,
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    this.reBackData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        // 获取售后订单状态
        getOrderState() {
            this.$util
                .axiosGet({
                    url: `/api/MallSaleOrder/GetAfterSaleStateList`,
                    data: {},
                    exception: true
                })
                .then(res => {
                    let data = res.data;
                    this.orderState = data;
                })
                .catch(() => {});
        },
        // 获取企业售后订单统计
        getStatistics() {
            this.$util
                .axiosGet({
                    url: `/api/MallSaleOrder/GetSaleOrderAfterSaleCount`,
                    data: {
                        UserId: this.searchData.UserId
                    },
                    exception: true
                })
                .then(res => {
                    let data = res.data;
                    this.statistics = data;
                })
                .catch(() => {});
        },
        // 跳转到申请页
        gotoReBack() {
            this.$router.push('./applyAfter');
        },
        // 撤销申请
        cancel(item) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要撤销申请售后吗？',
                confirmMsg: '撤销成功',
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/MallSaleOrder/CancelSaleOrderAfterSale`,
                            data: {
                                afterSaleId: item.AfterSaleId,
                                orderType: item.OrderType,
                                userId: that.searchData.UserId
                            }
                        })
                        .then(() => {
                            that.getOrderList();
                            that.getStatistics();
                        })
                        .catch(() => {});
                }
            });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        // 获取N个月前/后的日期
        getMonthDate(num) {
            let date = new Date();
            date.setMonth(date.getMonth() + num);
            return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        }
    }
};
</script>
<style lang="less" scoped>
.goods-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    img {
        width: 50px;
        height: 50px;
        margin-right: 10px;
    }
}
.goods-show {
    display: flex;
    align-items: center;
    margin-right: 10px;
}
.no-data {
    text-align: center;
    font-size: @font-lg;
}
.cancel {
    cursor: pointer;
    color: @theme;
}
.gotoReBack {
    cursor: pointer;
    color: @theme;
}
.num-show {
    .num-value {
        font-size: 42px;
        padding-bottom: 10px;
    }
    .div-table-cell {
        flex-direction: column;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100px;
        img {
            width: 50px;
            height: 50px;
            margin-bottom: 10px;
        }
    }
}
.reBack-table {
    margin-top: 50px;
}
.reBack-title {
    text-align: center;
    line-height: 35px;
    background: @border3Color;
}
.reBack-data {
    .div-table-cell {
        display: flex;
        align-items: center;
        height: 60px;
        padding-left: 10px;
        img {
            width: 50px;
            height: 50px;
            margin-right: 10px;
        }
    }
}
</style>
